import { toast } from "ngx-sonner";

/** Single shared toast slot for time-entry undo (edit and delete). */
export const TIME_ENTRY_UNDO_TOAST_ID = "tg-time-entry-undo";

export function dismissTimeEntryUndoToast(): void {
	toast.dismiss(TIME_ENTRY_UNDO_TOAST_ID);
}
